import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
    },
    tab: {
        ' & .Mui-selected span': {
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#8dd9c8;',
        },
        "& .MuiTab-root.Mui-selected": {
            fontSize: '15px',
            fontWeight: 'bold',
            color: '#8dd9c8;',
        }
    },
    tabItem: {
        color: '#0d273e',
        fontSize: '16px',
        minHeight: "20px !important",
    },
    tabItemRight: {
        color: '#0d273e',
        fontSize: '16px',
        float: 'right'
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 230,
    }
}));

export default useStyles;